import { SsoItemContainer, SsoItemTitleContainer } from './styled-components.js'
import { ImageLoader } from './image-loader.jsx'
import { iconSizeOptions } from '../../../../components/stories/atoms/icons/icons-sizes.js'

export const SsoItem = ({ logo, title, url }) => {
  return (
    <SsoItemContainer href={url} target="_self">
      <ImageLoader src={logo} alt={title} size={iconSizeOptions['ICON-L']} />
      <SsoItemTitleContainer>
        <span>{title}</span>
      </SsoItemTitleContainer>
    </SsoItemContainer>
  )
}
